function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface74063139"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.000001%,40.000001%,40.000001%)",
      fillOpacity: 1
    },
    d: "M 48 4 C 34.703125 4 24 14.703125 24 28 L 24 32 C 19.628906 32 16 35.628906 16 40 L 16 80 C 16 84.371094 19.628906 88 24 88 L 72 88 C 76.371094 88 80 84.371094 80 80 L 80 40 C 80 35.628906 76.371094 32 72 32 L 72 28 C 72 14.703125 61.296875 4 48 4 Z M 48 12 C 57.105469 12 64 18.894531 64 28 L 64 32 L 32 32 L 32 28 C 32 18.894531 38.894531 12 48 12 Z M 24 40 L 72 40 L 72 80 L 24 80 Z M 48 52 C 43.601562 52 40 55.601562 40 60 C 40 64.398438 43.601562 68 48 68 C 52.398438 68 56 64.398438 56 60 C 56 55.601562 52.398438 52 48 52 Z M 48 52 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.dcc6bb07.svg";
export { ForwardRef as ReactComponent };